import { db } from '../../common/config/Firebase';
import firebase from 'firebase/app';
import moment from 'moment';

/**
 * Fetches all employee vacations for a specific date range
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End date
 * @returns {Promise<Array>} - Array of vacation objects
 */
export const getAllEmployeeVacationsUseCase = async (startDate, endDate) => {
    try {
        const start = firebase.firestore.Timestamp.fromDate(moment(startDate).startOf('day').toDate());
        const end = firebase.firestore.Timestamp.fromDate(moment(endDate).endOf('day').toDate());

        // Query vacations that overlap with the date range
        // A vacation overlaps if: startDate <= vacation.endDate AND endDate >= vacation.startDate
        const snapshot = await db
            .collection('employeeVacations')
            .where('startDate', '<=', end)
            .get();

        const vacations = [];
        snapshot.forEach(doc => {
            const data = doc.data();
            const vacationEndDate = data.endDate.toDate();

            // Filter out vacations that end before our start date
            if (vacationEndDate >= startDate) {
                vacations.push({
                    id: doc.id,
                    employeeDni: data.employeeDni,
                    startDate: data.startDate.toDate(),
                    endDate: vacationEndDate,
                    description: data.description || '',
                    createdAt: data.createdAt ? data.createdAt.toDate() : null
                });
            }
        });

        console.log(`Fetched ${vacations.length} employee vacations for date range`);
        return vacations;
    } catch (error) {
        console.error('Error fetching all employee vacations:', error);
        return []; // Return empty array on error to not break the UI
    }
};

/**
 * Checks if a specific employee is on vacation on a given date
 * @param {string} employeeDni - Employee DNI
 * @param {number} timestamp - Date timestamp
 * @param {Array} vacations - Array of vacation objects
 * @returns {boolean} - True if the employee is on vacation
 */
export const isEmployeeOnVacation = (employeeDni, timestamp, vacations) => {
    const date = moment(timestamp).startOf('day');

    return vacations.some(vacation => {
        if (vacation.employeeDni !== employeeDni) return false;

        const vacationStart = moment(vacation.startDate).startOf('day');
        const vacationEnd = moment(vacation.endDate).endOf('day');

        return date.isSameOrAfter(vacationStart) && date.isSameOrBefore(vacationEnd);
    });
};
